import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Autocomplete, Box, Container, Grid, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Accordion, AccordionSummary, AccordionDetails, Stack, Hidden } from "@mui/material"
import Bottom from "./Bottom";
import { useEffect } from "react";
import api from "../utils/api";

import useComparisonHospitalStore from "../store/ComparisonHospitalStore";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import tab04 from "../assets/images/tab_01.png"

const CustomerServiceFaq = () => {


  return (
    <Container className="container">
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900 }}>
              고객센터
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              자주묻는 질문
            </Typography>
          </Grid>
        </Grid>
      </Box>

            <Box sx={noticeBox}>

              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>예약이 잘 되었는지 어떻게 확인하나요?</Typography>
                    </Stack>
                    <Stack>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    예약 홈페이지의 &lt;내예약 - 예약현황&gt; 메뉴에서 확인하실 수 있습니다.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>공복 시 물도 마시면 안 되나요?</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}>
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    검진 전날 잠들기 전까지 소량의 물은 마셔도 괜찮습니다. 하지만 검진 당일에는 물, 담배, 껌, 사탕 등 모두 금지입니다.
                    <br />모든 섭취는 몸속 전해질 농도를 변하게 해 검사결과에 영향을 줄 수 있기 때문에 반드시 공복을 지켜주셔야 검사를 진행할 수 있습니다.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>평소 복용하던 약은 어떻게 해야 하나요?</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}>
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    《 당뇨약·인슐린 주사 》<br />
                    <Typography sx={{ pl: 1, fontSize: 14 }} >
                      - 검진 전날 : 평소와 같이 복용하세요.<br />
                      - 검진 당일 : 아침에는 복용하지 마세요.<br />
                      - 검사가 끝난 후 : 식사 가능할 경우 복용하세요.<br />
                      &nbsp;&nbsp;※ 당뇨약 중 메폴민은 조영제와 반응할 시 신장 독성이 증가하기 때문에 검사 전 주치의와 상담이 필요합니다.<br /><br />
                    </Typography>
                    <hr />
                    <br />《 혈압약 》<br />
                    <Typography sx={{ pl: 1, fontSize: 14 }} >- 검진 당일 : 새벽 5시 무렵 소량의 물과 함께 복용하시기 바랍니다.<br /><br /></Typography>
                    <hr />

                    <br />《 혈전용해제, 아스피린, 항응고제 》<br />
                    <Typography sx={{ pl: 1, fontSize: 14 }} >
                      - 주치의와 복용 여부에 대해 상담 후 검진 7일 전부터는 중단하시기 바랍니다.<br />
                      ※ 중단을 못 하신 경우 검진 당일 반드시 직원에게 말씀해 주시기 바랍니다.
                    </Typography>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>종합검진 소요시간은 얼마나 걸리나요?</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}>
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    건강검진 당일은 공복 상태로 오셔야 하며 약 2시간 30분 ~ 3시간 정도 소요될 수 있습니다.<br />
                    수면 진행 여부, 병원의 건강검진 대기자 상황 등 환경에 따라 소요시간은 달라질 수 있습니다.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>임신 가능성이 있는데 검진을 받아도 될까요?</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}>
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    건강검진 검사 중에는 약물을 사용하는 검사, 방사선이 나오는 검사들이 있습니다.<br />
                    수면 위내시경, 위장 조영촬영, 흉부 X-선, 유방 X-선, 그리고 부인과 검사들은
                    태아에게 영향을 미칠 수 있기에 해당 검사를 제외하고 건강검진을 진행할 수 있으며
                    건강검진 일정을 조율하는 방법도 가능합니다.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>건강검진 예약일과 생리일이 겹칠 것 같아요.</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}>
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    건강검진 일정을 조율하는 것이 가장 바람직하나, 일정조율이 불가피할 경우<br />
                    건강검진 항목에서 소변 검사와 부인과 검사를 제외하고 진행할 수 있으며,<br />
                    진행하지는 않은 검사는 병원과 상의하여 완료하실 수 있습니다.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>MRI와 MRA의 차이점은 무엇인가요?</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}>
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    MR 검사는 자기장과 고주파의 상호작용을 이용하여 인체의 해부학적, 병리학적 정보를 얻을 수 있는 검사입니다.<br />
                    뇌 MRI는 치매, 뇌종양 등 뇌의 구조적, 기능적 이상소견 여부를 확인하고자 하는 목적이며<br />
                    뇌 MRA는 동맥류, 혈관 기형, 혈관 형태 등 뇌혈관 이상을 확인하기 위해 혈관만을 영상화하는 검사입니다.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>젊은 2·30대도 건강검진이 필요할까요?</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}>
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    불규칙한 생활습관과 서구화된 식습관 탓에 ‘대사증후군’이 나타날 가능성이 높아짐에 따라<br />
                    20~30대는 고혈압, 당뇨, 고지혈증 등 만성질환 발견에 중점을 두어야 합니다.<br />
                    (대사증후군은 복부비만, 고혈압, 혈당 장애, 고중성지방, 낮은 LDL 콜레스테롤 중 3가지 이상이 나타나는 상태를 말합니다.)
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>위·대장내시경 후 불편사항은 무엇인가요?</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}>
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    검사 후 일시적으로 인후통이나 불편감, 출혈이 발생할 수 있으나 시간이 지나면서 호전됩니다.<br />
                    위내시경 후 복부의 불쾌감이나 통증이 느껴질 수 있으나 대부분 일시적인 증상이며<br />
                    내시경 진행 시 원활한 검사를 위해 공기를 주입하면서 위와 장을 부풀리게 되어 배에 가스가 찬 느낌이 발생하는 것입니다.<br />
                    트림이나 방귀로 가스를 배출하시면 복부 불편감이 감소합니다.
                  </Typography>
                </AccordionDetails>
              </Accordion>


              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>수면 내시경 후 기억나지 않는 부분이 있어요.</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}>
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    수면내시경 검사 시 사용되는 약물은 의식을 진정시키고 단기적인 기억상실을 유도합니다.<br />
                    내시경 검사 후에도 이러한 약물 작용이 일부 지속되어 의사의 지시에 응하고 대답할 수 있을 정도로 의식은 명료하지만,<br />
                    나중에 마치 잠을 자고 난 뒤처럼 무엇을 했는지 기억하지 못하실 수 있습니다.<br />
                    수면검사 후 충분한 휴식을 취하시면 불편감 해소에 도움이 됩니다.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>대장내시경 검사 주기는?</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}>
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={noticeDetail}>
                    전체 대장내시경 검사시행 후 결과가 정상이고, 불편사항 또는 가족력이 없다면 3~5년 주기로 확인하시면 됩니다.<br />
                    불편증상, 과거력, 가족력이 있으면 2~3년 주기. 없으면 4~5년마다 재검진하실 것을 권유 드립니다.<br />
                    단, 용종을 제거하신 경우 1~2년 뒤 재검사가 필요하며 특히, 제거하신 용종이 선종이라면 다음 해에 재검사가 필요합니다.
                  </Typography>
                </AccordionDetails>
              </Accordion>

            </Box>


      <Bottom />
    </Container>
  )
}

const img ={ 
  display: 'flex', p: 0, backgroundImage: `url(${tab04})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}


const noticeBox = {
  width: '80%', mr : 'auto',  ml : 'auto',
  boxSizing: 'border-box',
  '& .MuiAccordion-root:first-of-type': { borderTopLeftRadius: 20, borderTopRightRadius: 20, },
  '& .MuiAccordion-root:last-of-type': { borderBottomLeftRadius: 20, borderBottomRightRadius: 20, }
}

const noticeTitle = {
  fontSize: 16,
  fontWeight: 700,
  color: '#555',
  pr: 2,
  '&::before': {
    content: '"Q"',
    fontSize:30,
    paddingRight: 2,
    color:'#0d6703'
  }
  /*  overflow: 'hidden',
   textOverflow: 'ellipsis',
   display: '-webkit-box',
   '-webkitLineClamp': '2',
   '-webkitBoxOrient': 'vertical' */
}
const noticeDate = {
  fontSize: 14,
  color: '#777'
}

const dateIcon = {
  fontSize: 16,
  color: '#888',
  verticalAlign: 'sub',
  mr: '5px'
}

const noticeDetail = {
  fontSize: 16,
  pl:6,
  color: '#555',
  whiteSpace: 'pre-wrap',
  '&::before': {
    content: '"A"',
    position:'absolute',
    left:'30px',
    marginTop:'-10px',
    fontSize:30,
    paddingRight: 2,
    color:'#8acd83'
  }
}

export default CustomerServiceFaq;